import { AccountFormModel } from "../../app/form";

export class AccountRequest {
  email: string;

  constructor(trailerTypeForm: AccountFormModel) {
    this.email = trailerTypeForm.email;
  }
}
